// extracted by mini-css-extract-plugin
export default {"notfound":"error_notfound__5J9SW","notfound404":"error_notfound404__bR8Ys"};